import React, { Component } from 'react';

export default class Option extends Component {
  static isSelectOption = true;
}
